import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { LoadingService } from 'app/core/services/loading.service';
import * as ExcelJS from 'exceljs/dist/exceljs';
import { ToastService } from 'app/toast/services/toast.service';

@Injectable({
  providedIn: 'root'

})
export class PeerToPeerManageService {
  
  public totalP2PCampaigns = 0;

  public filteredByCategoty = []
  public filteredItems = []
  public p2pReport = []
  public p2pItemsFilterActive = 0

  public searchQuery = ''
  public category = 'All'
  public filterButtonText = 'All'

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private loadingService: LoadingService,
    private toastService: ToastService
  ) { }

  filterP2pItems(){
    switch(this.category){
      case 'All':
          this.filteredItems = this.p2pReport
          this.filteredByCategoty = [...this.p2pReport]
          break;
      default:
        this.filteredItems = this.p2pReport.filter(item => item.teamId === this.category)
        this.filteredByCategoty = [...this.filteredItems]
    }
    this.filteredItems = _.filter(this.filteredByCategoty, (item: any) => {
        return item.displayName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        item.createdByName.toLowerCase().includes(this.searchQuery.toLowerCase()) || 
        item.userInfo.email.toLowerCase().includes(this.searchQuery.toLowerCase()) || 
        item.userInfo.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      });
  }

  getP2PCampaignList() {
    const token = this.cookieService.get('accessToken');

    this.loadingService.enabled = false;
    return this.http.post('/api/p2p/p2p/get/campaigns', `access_token=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  getPeerToPeerReport(campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({"campaignId":campaignId}))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/p2p/report', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));        
  }

  getPeerToPeerInfo(p2pItemId) {
    const queryParams = [
      `peerid=${p2pItemId}`,
      `requestType=admin`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/getPeerToPeerInfo', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  getCampaignDetail(campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `campaignId=${campaignId}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/campaign/detail', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));        
  }

  addDonation(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/p2p/addDonation', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  addFundraiser(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    return this.http.post('/api/p2p/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  // send p2pId and campaignId to notify specific Fundraiser
  // send only campaignId to notify all Fundraisers
  notify(campaignId, p2pId = '') {
    let params = {
      campaignId: campaignId
    }

    if(p2pId !== '') {
      params['p2pId'] = p2pId;
    }

    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/p2p/update/send', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  update(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/p2p/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  getUserExcelData(transactionData) {
    var userExcelData = [];
    for (let i = 0; i < transactionData.length; i++) {
      var info = {
        Name: transactionData[i].payer.name,
        Email: transactionData[i].payer.email,
        Amount: this.addCommasToNumber(transactionData[i].amount),
        Date: this.getFullDate(transactionData[i].created)
      }
      userExcelData.push(info);
    }
    return userExcelData;
  }

  exportToExcel(excelData, fileName){
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Donations');

    worksheet.columns = [
      { header: 'Name', width: 20 },
      { header: 'Email', width: 25 },
      { header: 'Amount', width: 10 },
      { header: 'Date', width: 13 },
    ];

    const dataArray = excelData.map(row => Object.values(row));
    worksheet.addRows(dataArray);

    workbook.xlsx.writeBuffer()
    .then(buffer => {
      this.saveExcelFile(buffer, fileName);
    })
    .catch(error => {
      this.toastService.show('danger', 'Error saving the file', {delay: 2000} );
    });
  }

  saveExcelFile(buffer, fileName) {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(data);
    downloadLink.download = fileName;
    downloadLink.click();
  }

  getFullDate(timestamp) {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}/${month}/${day}`
  }

  deleteP2P(itemId) {
    let reqParam = {"id" :itemId}

    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(reqParam))}`
    ];

    return this.http.post('/api/p2p/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }

  deleteP2PPledge(id) {
    const param = {"id" :id}
    const queryParams = [
      `p=${encodeURIComponent(JSON.stringify(param))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/p2p/pledge/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  saveP2PEventCount(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/p2p/pledge/eventCount/save', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  addCommasToNumber(number) {
    return window['utils'].getAmountDisplay(number);
  }

  p2pChangeUserImage(params){
    return this.http.post('/api/p2p/update', `p=${encodeURIComponent(JSON.stringify(params))}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }

  fulfillAllDonors(params){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('api/p2p/pledge/close', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }

  getDownloadQRCards(campaignId){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({campaignId}))}`
    ];

    return this.http.post('/api/p2p/qr_cards/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }

  getDownloadQRCardsByUser(campaignId, p2pId = ''){
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({campaignId, p2pId}))}`
    ];

    return this.http.post('/api/p2p/qr_cards/byuser/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }
}

